// import React, { useState, useMemo, useEffect } from "react"
// import { Row, Col, Card, Table, Modal, Label, Form } from "reactstrap"
// import {
//   useTable,
//   useSortBy,
//   usePagination,
//   useGlobalFilter,
// } from "react-table"
// import Select from "react-select"
// // assets
// import Loader from "pages/Separate/Loader"
// import NewPagination from "components/Common/Newpagination"
// import {
//   checkPermissionsByModule,
//   customGlobalFilter,
//   formatBytes,
// } from "utils/common-helpers"
// import { searchColumns } from "utils/columns/ElementsColumns/searchColumns"
// import viewImg from "../../../assets/images/Inventory/viewImg.jpg"
// import { CKEditor } from "@ckeditor/ckeditor5-react"
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
// import Dropzone from "react-dropzone"
// import {
//   fetchData,
//   fetchNodeData,
//   FetchNodePostData,
// } from "utils/common-fetchData"
// import secureLocalStorage from "react-secure-storage"
// import configure from "configure"
// import { colourStyles, searchModules } from "utils/common-options"
// import moment from "moment"
// import AddTasks from "pages/Dashboard/GeneralTask/AddTasks"
// import { useSelector } from "react-redux"
// import Swal from "sweetalert2"
// import axios from "axios"
// import { setSearchData } from "store/search/actions"
// import { useDispatch } from "react-redux"

// function TableContainer({ columns, data, setData, toggleLoading, token }) {
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     page,
//     state,
//     previousPage,
//     nextPage,
//     canPreviousPage,
//     canNextPage,
//     gotoPage,
//     setPageSize,
//     pageOptions,
//     setGlobalFilter,
//     pageCount,
//     prepareRow,
//   } = useTable(
//     {
//       columns,
//       data,
//       globalFilter: customGlobalFilter,
//       initialState: {
//         sortBy: [
//           {
//             id: "id",
//             desc: true,
//           },
//         ],
//       },
//     },

//     useGlobalFilter,
//     useSortBy,
//     usePagination
//   )
//   const { pageIndex, pageSize, globalFilter } = state
//   const roles = useSelector(state => state?.Roles?.apiData)
//   const [moduleOption, setModuleOption] = useState([])

//   useEffect(() => {
//     setPageSize(10)
//     setModuleOption(
//       searchModules.filter(module =>
//         module?.value != 0
//           ? checkPermissionsByModule(roles, module.value, 2)
//           : module
//       )
//     )
//   }, [])
//   // Render the UI for your table
//   const [search, setSearch] = useState(false)
//   const [selected, setSelected] = useState([])
//   const isAllSelected = selected.some(opt => opt.value === "0")
//   const isOtherSelected = selected.some(opt => opt.value !== "0")
//   const [searchValue, setSearchValue] = useState("")

//   const options = moduleOption.map(opt => ({
//     ...opt,
//     isDisabled: isAllSelected
//       ? opt.value !== "0"
//       : isOtherSelected && opt.value === "0",
//   }))
//   const dispatch = useDispatch()
//   const searchData = useSelector(state => state?.SearchData?.searchData)
//   const onSearchData = async () => {
//     const moduleid = selected?.map(obj => obj?.value)?.join(",")
//     const formEntries = {
//       q: searchValue,
//       module: moduleid != 0 ? moduleid : null,
//       user_id: localStorage.getItem("auth_id"),
//     }
//     const res = await FetchNodePostData(
//       toggleLoading,
//       "globalSearch",
//       token,
//       formEntries
//     )
//     if (res) {
//       setData(res?.data)
//       dispatch(
//         setSearchData({
//           data: res?.data,
//           value: searchValue,
//           module: moduleid != 0 ? moduleid : null,
//         })
//       )
//     }
//   }

//   useEffect(() => {
//     if (searchData?.length != 0) {
//       setData(searchData?.data)
//       const assignee = options?.filter(item =>
//         searchData?.module?.includes(item.value)
//       )
//       setSelected(
//         assignee?.length != 0
//           ? assignee
//           : [
//               {
//                 value: "0",
//                 label: "All Module",
//               },
//             ]
//       )
//       setSearchValue(searchData?.value)
//     }
//   }, [searchData])

//   return (
//     <div>
//       <Row>
//         <Col xl="12">
//           <div className="card-bodys">
//             <div className="d-flex justify-content-between mb-2 mt-3">
//               <div className="">
//                 {search ? (
//                   <div>
//                     <div className="col-1 me-md-5">
//                       <select
//                         className="border-radius form-select"
//                         style={{ width: "100px" }}
//                         value={pageSize}
//                         onChange={e => setPageSize(e.target.value)}
//                       >
//                         {[10, 25, 50, 100].map(pageSize => (
//                           <option key={pageSize} value={pageSize}>
//                             Show {pageSize}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 ) : null}
//               </div>
//               <div className="d-flex col-md-8 align-items-center justify-content-end">
//                 <div className="col-md-6 me-3">
//                   <Select
//                     placeholder="Select Module"
//                     className="basic-multi-select"
//                     classNamePrefix="select"
//                     options={options}
//                     isMulti
//                     value={selected}
//                     onChange={setSelected}
//                     isOptionDisabled={option => option.isDisabled}
//                     closeMenuOnSelect={false}
//                   />
//                 </div>
//                 <div className="me-3 col-md-6">
//                   <input
//                     id="search-bar-0"
//                     type="text"
//                     className=" form-control h-100 w-100 "
//                     placeholder={`Search Globaly...`}
//                     value={searchValue}
//                     onChange={e => setSearchValue(e.target.value)}
//                     onKeyDown={e => {
//                       if (e.key === "Enter") {
//                         onSearchData()
//                       }
//                     }}
//                   />
//                 </div>
//                 <button
//                   className="btn btn-sm  bg-purple text-white me-2  "
//                   onClick={e => {
//                     onSearchData()
//                   }}
//                 >
//                   <i className="bi bi-funnel-fill fs-6"></i>
//                 </button>
//                 <button
//                   className="btn btn-sm  me-1 bg-warning  text-white "
//                   onClick={e => {
//                     setSelected([])
//                     setSearchValue("")
//                     setData([])
//                     dispatch(setSearchData([]))
//                     setSearch(false)
//                   }}
//                 >
//                   <i className="bi bi-x fs-6"></i>
//                 </button>
//               </div>
//             </div>
//             {data?.length != 0 ? (
//               <>
//                 <div className="position-relative table-responsive search-history-slots">
//                   <Table
//                     className="table table-bordered mt-4"
//                     {...getTableProps()}
//                   >
//                     <thead className={``}>
//                       {headerGroups.map((headerGroup, i) => (
//                         <tr key={i} {...headerGroup.getHeaderGroupProps()}>
//                           {headerGroup.headers.map((column, index) => (
//                             <th
//                               key={index}
//                               className={`t-col-${index + 1} ${
//                                 column.className
//                               }`}
//                               {...column.getHeaderProps(
//                                 column.getSortByToggleProps()
//                               )}
//                             >
//                               <div className="d-flex align-items-center">
//                                 <span className="flex-grow-1 text-center header-text">
//                                   {column.render("Header")}
//                                 </span>
//                                 {column.isShortIcon && (
//                                   <span
//                                     onClick={() =>
//                                       column.getSortByToggleProps().onClick()
//                                     }
//                                     className="d-flex align-items-center ms-2"
//                                   >
//                                     <i
//                                       title="Ascending"
//                                       className={`bi bi-arrow-up info-icon ${
//                                         column.isSorted && !column.isSortedDesc
//                                           ? "text-dark"
//                                           : ""
//                                       }`}
//                                     ></i>
//                                     <i
//                                       title="Descending"
//                                       className={`bi bi-arrow-down info-icon ${
//                                         column.isSorted && column.isSortedDesc
//                                           ? "text-dark"
//                                           : ""
//                                       }`}
//                                     ></i>
//                                   </span>
//                                 )}
//                               </div>
//                             </th>
//                           ))}
//                         </tr>
//                       ))}
//                     </thead>

//                     <tbody
//                       className="fix-introducer-header"
//                       {...getTableBodyProps()}
//                     >
//                       {page.map((row, i) => {
//                         prepareRow(row)
//                         return (
//                           <tr
//                             className={`row-hover`}
//                             {...row.getRowProps()}
//                             key={i}
//                           >
//                             {row.cells.map((cell, index) => {
//                               return (
//                                 <td
//                                   key={index}
//                                   className={`t-col-${index + 1} ${
//                                     cell.column.className
//                                   }`}
//                                   {...cell.getCellProps()}
//                                 >
//                                   {cell.render("Cell")}
//                                 </td>
//                               )
//                             })}
//                           </tr>
//                         )
//                       })}
//                     </tbody>
//                   </Table>
//                 </div>

//                 <Row className="justify-content-md-end justify-content-center align-items-center">
//                   <NewPagination
//                     gotoPage={gotoPage}
//                     canPreviousPage={canPreviousPage}
//                     previousPage={previousPage}
//                     canNextPage={canNextPage}
//                     pageIndex={pageIndex}
//                     pageOptions={pageOptions}
//                     pageSize={pageSize}
//                     page={page}
//                     data={data}
//                     nextPage={nextPage}
//                   />
//                 </Row>
//               </>
//             ) : (
//               <div className="d-flex flex-column align-items-center justify-content-center p-3">
//                 <div className="col-md-4 d-flex flex-column align-items-center justify-content-center">
//                   <img src={viewImg} alt="Image" width={200} />
//                   <p className="text-purple fw-bold text-center lh-base">
//                     🔍 Your Data Search is Ready! Use the selected module
//                     filters to search and explore relevant data across the
//                     entire application with ease. 📂📈
//                   </p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </Col>
//       </Row>
//     </div>
//   )
// }

// const GlobalSearchElement = () => {
//   const [isLoading, setLoading] = useState(false)
//   const [data, setData] = useState([])
//   const [quickNotes, setQuickNotes] = useState(false)
//   const [addGeneralTask, setAddGeneralTask] = useState(false)
//   const [allNotes, setAllNotes] = useState([])
//   const token = secureLocalStorage.getItem("auth_token")
//   const [boxWidth, setBoxWidth] = useState(0)
//   const [lead_id, setLeadId] = useState("")
//   const [currency_option, setCurrencyOption] = useState([])
//   const toggleLoading = loading => {
//     setLoading(loading)
//   }

//   const [selectedFiles1, setselectedFiles1] = useState([])

//   function handleAcceptedFiles1(files) {
//     files.map(file =>
//       Object.assign(file, {
//         preview: URL.createObjectURL(file),
//         formattedSize: formatBytes(file.size),
//       })
//     )
//     setselectedFiles1(files)
//   }

//   const getNotes = async leadId => {
//     setLeadId(leadId)
//     const response = await fetchNodeData(
//       toggleLoading,
//       `leadNotesData?lead_id=${leadId}`,
//       token
//     )
//     if (response?.status) {
//       setAllNotes(response.data.notes)
//       setQuickNotes(true)
//       setCurrencyOption(
//         response?.data?.currency?.map(item => ({
//           label: item.currency,
//           value: item.id,
//         }))
//       )
//     }
//   }
//   const column1 = useMemo(() => searchColumns(getNotes), [])

//   useEffect(() => {
//     const updateWidth = () => {
//       const viewportWidth = window.innerWidth
//       setBoxWidth(viewportWidth * 0.95)
//     }
//     updateWidth()
//     window.addEventListener("resize", updateWidth)
//     return () => window.removeEventListener("resize", updateWidth)
//   }, [])
//   const onCloseAddModal = close => {
//     setAddGeneralTask(close)
//   }
//   const [currency, setCurrency] = useState([])
//   const curentDateTime = moment().format("YYYY-MM-DDTHH:mm")
//   const [notedate, setNotedate] = useState(curentDateTime)
//   const [amount, setAmount] = useState("")
//   const [ckedata, setCkedata] = useState("")

//   const addNotes = async e => {
//     e.preventDefault()
//     setLoading(true)
//     const formData = new FormData()
//     formData.append("lead_id", lead_id)
//     formData.append("user_id", localStorage.getItem("auth_id"))
//     formData.append("currency", currency.value != null ? currency.value : "")
//     formData.append("date", notedate)
//     formData.append("amount", amount)
//     formData.append("description", ckedata)
//     for (let i = 0; i < selectedFiles1.length; i++) {
//       formData.append("files[]", selectedFiles1[i])
//     }
//     try {
//       const response = await axios({
//         method: "post",
//         url: `${configure.apiUrl}/add_lead_note`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then(response => {
//         setLoading(false)
//         Swal.fire({
//           icon: "success",
//           text: "Note Added Successfully",
//         }).then(data => {
//           setCkedata("")
//           setAmount("")
//           setAllNotes(response.data.data)
//         })
//       })
//     } catch (error) {
//       console.log(error)
//       setLoading(false)
//     }
//   }

//   return (
//     <React.Fragment>
//       <>
//         {isLoading && <Loader />}
//         <div className="">
//           <div>
//             <Row>
//               <Col lg="12">
//                 <Card>
//                   <div className="responsive-table">
//                     <TableContainer
//                       columns={column1}
//                       data={data}
//                       toggleLoading={toggleLoading}
//                       token={token}
//                       setData={setData}
//                     />
//                   </div>
//                 </Card>
//               </Col>
//             </Row>
//           </div>

//           <Modal
//             isOpen={quickNotes}
//             toggle={() => {
//               setQuickNotes(false)
//             }}
//             size="xl"
//             className="bd-notes-search"
//             centered
//           >
//             {isLoading && <Loader />}
//             <div className="modal-header border-0">
//               <h5 className="modal-title mt-0">Add Notes</h5>
//               <button
//                 type="button"
//                 className="btn-modal-close"
//                 onClick={() => setQuickNotes(false)}
//               >
//                 <span aria-hidden="true" className="btn-modal-span">
//                   ×
//                 </span>
//               </button>
//             </div>
//             <div className="modal-body pb-0">
//               <div className="row">
//                 <div className="col-md-6">
//                   <h5 className="text-dark">Notes History</h5>
//                   <div
//                     className="mt-4"
//                     style={{
//                       maxHeight: "530px",
//                       overflowY: "auto",
//                       scrollbarWidth: "thin",
//                     }}
//                   >
//                     <ul className="verti-timeline list-unstyled notes-box">
//                       {allNotes?.map((note, i) => {
//                         return (
//                           <li className="event-list position-relative" key={i}>
//                             <div className="event-timeline-dot connected-dot">
//                               <img
//                                 src={`${configure.imgUrl}${note?.addedby_avatar}`}
//                                 className="msgUserImg me-3"
//                                 alt="User Avatar"
//                               />
//                             </div>
//                             <div className="d-flex">
//                               <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
//                                 <div className="d-flex justify-content-start align-items-center">
//                                   <div>
//                                     <p className="text-muted ">
//                                       <h6 className="d-inline me-2">
//                                         By {note.added_by}
//                                       </h6>{" "}
//                                       {moment(note.created_at).format(
//                                         "DD-MM-YYYY hh:mm:ss"
//                                       )}
//                                       <span className="pl-15">
//                                         Got in touch with this lead at{" "}
//                                         {moment(note.date).format(
//                                           "DD-MM-YYYY hh:mm a"
//                                         )}
//                                       </span>
//                                     </p>
//                                   </div>
//                                 </div>
//                                 <i className="bi bi-triangle-fill note-icon"></i>
//                                 <div
//                                   className="Features word-wrap"
//                                   dangerouslySetInnerHTML={{
//                                     __html: note.description,
//                                   }}
//                                 />
//                                 <p className="mb-2">
//                                   Amount : {note.currency_symbol} {note.amount}{" "}
//                                 </p>
//                                 {note.link != null ? (
//                                   <p className="mb-1">
//                                     Attachment :{" "}
//                                     <a
//                                       target="_blank "
//                                       className="btn btn-sm edit-delete-btn text-secondary ml-10"
//                                       rel="noreferrer"
//                                       type="button"
//                                       href={note.link}
//                                     >
//                                       <i className="fas fa-eye"></i> View
//                                     </a>
//                                   </p>
//                                 ) : null}
//                               </div>
//                             </div>
//                           </li>
//                         )
//                       })}
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
//                     <Form className="w-100" onSubmit={addNotes}>
//                       <Row className="align-items-center justify-content-between">
//                         <div className="col-12 d-flex justify-content-between">
//                           <h5 className="text-dark">Add New Note</h5>
//                           <div className="text-end">
//                             {/* <a
//                               className="btn btn-save  me-2 btn-label"
//                               onClick={() => setAddGeneralTask(true)}
//                             >
//                               <i className="fas fa-plus me-2 label-icon"></i>{" "}
//                               Activity
//                             </a>
//                             */}
//                             <a
//                               className="btn btn-save  me-2 btn-label"
//                               type="button"
//                               href={`${configure.appUrl}calender/lead-${lead_id}`}
//                               target="_blank"
//                               rel="noreferrer"
//                             >
//                               <i className="fa fa-users me-2 label-icon"></i>
//                               Add Meeting
//                             </a>

//                             <button className="btn btn-save  me-2 btn-label">
//                               <i className="fas fa-plus me-2 label-icon"></i>Add
//                               Note
//                             </button>
//                           </div>
//                         </div>
//                         <div className="" style={{ width: "98%" }}>
//                           <label htmlFor="">Description</label>
//                           <div
//                             className="no-drag"
//                             // onDoubleClick={() => setNoDrag(true)}
//                             // onMouseLeave={() => setNoDrag(false)}
//                             // onMouseEnter={() => setNoDrag(true)}
//                           >
//                             <CKEditor
//                               editor={ClassicEditor}
//                               data={ckedata}
//                               onReady={editor => {}}
//                               onChange={(event, editor) => {
//                                 const data = editor.getData()
//                                 setCkedata(data)
//                               }}
//                             />
//                           </div>
//                         </div>
//                         <div className="col-md-4 mt-3 px-0 ps-2">
//                           <label htmlFor="">Currency</label>
//                           <Select
//                             onChange={e =>
//                               setCurrency({
//                                 label: e.label,
//                                 value: e.value,
//                               })
//                             }
//                             placeholder="Select Currency"
//                             className="basic-multi-select"
//                             classNamePrefix=" select"
//                             styles={colourStyles}
//                             options={currency_option}
//                             menuPlacement="top"
//                           />
//                         </div>
//                         <div className="col-md-3 mt-3  px-0 ps-2">
//                           <label htmlFor="">Amount</label>
//                           <input
//                             type="number"
//                             value={amount}
//                             onChange={e => setAmount(e.target.value)}
//                             placeholder="Enter Amount"
//                             className="form-control "
//                           />
//                         </div>
//                         <div className="col-md-5 mt-3 notes pe-4">
//                           <label htmlFor="touch">
//                             Got in touch with this lead{" "}
//                             <span className="text-danger"> *</span>
//                           </label>
//                           <input
//                             type="datetime-local"
//                             value={notedate}
//                             onChange={e => setNotedate(e.target.value)}
//                             required
//                             className="form-control "
//                           />
//                         </div>

//                         <div className="col-md-6 mt-3">
//                           <label htmlFor="">Attachment</label>
//                           <Dropzone
//                             onDrop={acceptedFiles => {
//                               handleAcceptedFiles1(acceptedFiles)
//                             }}
//                           >
//                             {({ getRootProps, getInputProps }) => (
//                               <div
//                                 className="dz-message needsclick p-0"
//                                 {...getRootProps()}
//                               >
//                                 <input {...getInputProps()} />
//                                 <div className="d-flex px-2 custom-file-upload align-items-center">
//                                   <div className="">
//                                     <i className="display-6 text-muted bx bxs-cloud-upload" />
//                                   </div>
//                                   <h5 className="mb-0 ms-2">Upload Files</h5>
//                                 </div>
//                               </div>
//                             )}
//                           </Dropzone>
//                         </div>
//                         <div
//                           className={`col-md-5 mt-3 dropzone-previews ${
//                             selectedFiles1.length > 0 ? "d-block" : "d-none"
//                           }`}
//                           id="file-previews"
//                         >
//                           <label className="mb-1">Uploaded Files</label>
//                           <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
//                             <div className="p-1">
//                               <Row className="align-items-center justify-content-evenly">
//                                 {selectedFiles1.map((f, i) => {
//                                   return (
//                                     <Col key={i} className="col-auto">
//                                       <img
//                                         data-dz-thumbnail=""
//                                         height="80"
//                                         className="avatar-sm rounded bg-light"
//                                         alt={f.name}
//                                         src={f.preview}
//                                       />
//                                     </Col>
//                                   )
//                                 })}
//                               </Row>
//                             </div>
//                           </Card>
//                         </div>
//                       </Row>
//                     </Form>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Modal>

//           <Modal
//             isOpen={addGeneralTask}
//             toggle={() => {
//               setAddGeneralTask(false)
//             }}
//             size="xl"
//             className="bd-notes-search"
//             centered
//           >
//             <div className="modal-body pt-0 ps-0">
//               <AddTasks
//                 // alldependency={alldependency}
//                 // tasks={tasks}
//                 onCloseAddModal={onCloseAddModal}
//                 toggleLoading={toggleLoading}
//               />
//             </div>
//           </Modal>
//         </div>
//       </>
//     </React.Fragment>
//   )
// }

// export default GlobalSearchElement







import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Card, Table, Modal, Label, Form } from "reactstrap";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import Select from "react-select";
// assets
import Loader from "pages/Separate/Loader";
import NewPagination from "components/Common/Newpagination";
import {
  checkPermissionsByModule,
  customGlobalFilter,
  formatBytes,
} from "utils/common-helpers";
import { searchColumns } from "utils/columns/ElementsColumns/searchColumns";
import viewImg from "../../../assets/images/Inventory/viewImg.jpg";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Dropzone from "react-dropzone";
import {
  fetchData,
  fetchNodeData,
  FetchNodePostData,
} from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import configure from "configure";
import { colourStyles, searchModules } from "utils/common-options";
import moment from "moment";
import AddTasks from "pages/Dashboard/GeneralTask/AddTasks";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import axios from "axios";
import { setSearchData } from "store/search/actions";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

function TableContainer({ columns, data, setData, toggleLoading, token }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination,
  );
  const { pageIndex, pageSize, globalFilter } = state;
  const roles = useSelector((state) => state?.Roles?.apiData);
  const [moduleOption, setModuleOption] = useState([]);

  useEffect(() => {
    setPageSize(10);
    setModuleOption(
      searchModules.filter((module) =>
        module?.value != 0
          ? checkPermissionsByModule(roles, module.value, 2)
          : module,
      ),
    );
  }, []);
  // Render the UI for your table
  const [search, setSearch] = useState(false);
  const [selected, setSelected] = useState([searchModules[0]]);
  const [searchValue, setSearchValue] = useState("");
  const [leadData, setLeadData] = useState([]);

  const isAllSelected = selected.some(
    (opt) => opt.value === "0" || opt.value === "1",
  );
  const isOtherSelected = selected.some((opt) => opt.value !== "0");
  const options = moduleOption.map((opt) => ({
    ...opt,
    isDisabled: isAllSelected
      ? opt.value !== "0"
      : isOtherSelected && (opt.value === "0" || opt.value === "1"),
  }));
  const dispatch = useDispatch();
  const searchData = useSelector((state) => state?.SearchData?.searchData);
  const onSearchData = async (
    page = 1,
    limit = 50,
    filters = {}, // <-- Add this
  ) => {
    setLeadData([]);
    setData([]);
    if (searchValue.length) {
      if (selected.some((opt) => opt.value === "1")) {
        const {
          location = "",
          asigned = "",
          status = "",
          source = "",
          lead_type = "",
          industry = "",
        } = filters;
        toggleLoading(true);
        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("location", location);
        formData.append("asigned", asigned);
        formData.append("status", status);
        formData.append("source", source);
        formData.append("lead_type", lead_type);
        formData.append("industry", industry);
        formData.append("page", page);
        formData.append("limit", limit);
        formData.append("keyword", searchValue);

        try {
          const response = await axios({
            method: "post",
            url: `${configure.nodeApi}/all_lead`,
            data: formData,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          });
          if (!response.data?.data?.length) swal("", "No results Found!");
          setLeadData(response.data.data || []);
        } catch (err) {
          console.log(err);
        } finally {
          toggleLoading(false);
        }
      } else {
        const moduleid = selected?.map((obj) => obj?.value)?.join(",");
        const formEntries = {
          q: searchValue,
          module: moduleid != 0 ? moduleid : null,
          user_id: localStorage.getItem("auth_id"),
        };
        const res = await FetchNodePostData(
          toggleLoading,
          "globalSearch",
          token,
          formEntries,
        );
        if (res) {
          setData(res?.data);
          dispatch(
            setSearchData({
              data: res?.data,
              value: searchValue,
              module: moduleid != 0 ? moduleid : null,
            }),
          );
        }
      }
    }
  };

  // useEffect(() => {
  //   if (searchData?.length != 0) {
  //     setData(searchData?.data)
  //     const assignee = options?.filter(item =>
  //       searchData?.module?.includes(item.value)
  //     )
  //     setSelected(
  //       assignee?.length != 0
  //         ? assignee
  //         : [
  //           {
  //             value: "1",
  //             label: "Lead",
  //           }
  //         ]
  //     )
  //     setSearchValue(searchData?.value)
  //   }
  // }, [searchData])

  useEffect(() => {
    if (searchData?.length != 0) {
      setData(searchData?.data);
      const assignee = options?.filter((item) =>
        searchData?.module?.includes(item.value),
      );
      setSelected(
        assignee?.length != 0
          ? assignee
          : [
              {
                value: "0",
                label: "All Module",
              },
            ],
      );
      setSearchValue(searchData?.value);
    }
  }, [searchData]);

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-bodys">
            <div className="d-flex justify-content-between mb-2 mt-3">
              <div className="">
                {search ? (
                  <div>
                    <div className="col-1 me-md-5">
                      <select
                        className="border-radius form-select"
                        style={{ width: "100px" }}
                        value={pageSize}
                        onChange={(e) => setPageSize(e.target.value)}
                      >
                        {[10, 25, 50, 100].map((pageSize) => (
                          <option key={pageSize} value={pageSize}>
                            Show {pageSize}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="d-flex col-md-8 align-items-center justify-content-end">
                <div className="col-md-6 me-3">
                  <Select
                    placeholder="Select Module"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    options={options}
                    isMulti
                    value={selected}
                    onChange={setSelected}
                    isOptionDisabled={(option) => option.isDisabled}
                    closeMenuOnSelect={false}
                  />
                </div>
                <div className="me-3 col-md-6">
                  <input
                    id="search-bar-0"
                    type="text"
                    className=" form-control h-100 w-100 "
                    placeholder={`Search Globaly...`}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        onSearchData();
                      }
                    }}
                  />
                </div>
                <button
                  className="btn btn-sm  bg-purple text-white me-2  "
                  onClick={(e) => {
                    onSearchData();
                  }}
                >
                  <i className="bi bi-funnel-fill fs-6"></i>
                </button>
                <button
                  className="btn btn-sm  me-1 bg-warning  text-white "
                  onClick={(e) => {
                    setSelected([]);
                    setSearchValue("");
                    setData([]);
                    setLeadData([]);
                    dispatch(setSearchData([]));
                    setSearch(false);
                  }}
                >
                  <i className="bi bi-x fs-6"></i>
                </button>
              </div>
            </div>
            {data?.length || leadData.length ? (
              <>
                {leadData.length ? (
                  <div
                    style={{
                      height: "60vh",
                      overflow: "auto",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <Table className="table table-bordered mt-4">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Company</th>
                          {/* <th>Name</th> */}
                          <th>Email ID</th>
                          <th>Phone</th>
                          <th>Source</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leadData.map((item) => {
                          return (
                            <tr key={item.id}>
                              <td>{item.id}</td>
                              <td>{item.company}</td>
                              {/* <td>{item.text}</td> */}
                              <td>{item.email}</td>
                              <td>{item.phonenumber}</td>
                              <td>{item.source}</td>
                              <td>{item.status}</td>
                              <td>
                                <Link
                                  to={`${configure.appUrl}sales/edit-lead/${item.id}`}
                                  target="_blank"
                                  title="View"
                                  className="btn btn-sm btn-outline-secondary me-1"
                                >
                                  <i className="fas fa-arrow-right"></i>
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <>
                    <div className="position-relative table-responsive search-history-slots">
                      <Table
                        className="table table-bordered mt-4"
                        {...getTableProps()}
                      >
                        <thead className={``}>
                          {headerGroups.map((headerGroup, i) => (
                            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                              {headerGroup.headers.map((column, index) => (
                                <th
                                  key={index}
                                  className={`t-col-${index + 1} ${
                                    column.className
                                  }`}
                                  {...column.getHeaderProps(
                                    column.getSortByToggleProps(),
                                  )}
                                >
                                  <div className="d-flex align-items-center">
                                    <span className="flex-grow-1 text-center header-text">
                                      {column.render("Header")}
                                    </span>
                                    {column.isShortIcon && (
                                      <span
                                        onClick={() =>
                                          column
                                            .getSortByToggleProps()
                                            .onClick()
                                        }
                                        className="d-flex align-items-center ms-2"
                                      >
                                        <i
                                          title="Ascending"
                                          className={`bi bi-arrow-up info-icon ${
                                            column.isSorted &&
                                            !column.isSortedDesc
                                              ? "text-dark"
                                              : ""
                                          }`}
                                        ></i>
                                        <i
                                          title="Descending"
                                          className={`bi bi-arrow-down info-icon ${
                                            column.isSorted &&
                                            column.isSortedDesc
                                              ? "text-dark"
                                              : ""
                                          }`}
                                        ></i>
                                      </span>
                                    )}
                                  </div>
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>

                        <tbody
                          className="fix-introducer-header"
                          {...getTableBodyProps()}
                        >
                          {page.map((row, i) => {
                            prepareRow(row);
                            return (
                              <tr
                                className={`row-hover`}
                                {...row.getRowProps()}
                                key={i}
                              >
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td
                                      key={index}
                                      className={`t-col-${index + 1} ${
                                        cell.column.className
                                      }`}
                                      {...cell.getCellProps()}
                                    >
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>

                    <Row className="justify-content-md-end justify-content-center align-items-center">
                      <NewPagination
                        gotoPage={gotoPage}
                        canPreviousPage={canPreviousPage}
                        previousPage={previousPage}
                        canNextPage={canNextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        page={page}
                        data={data}
                        nextPage={nextPage}
                      />
                    </Row>
                  </>
                )}
              </>
            ) : (
              <div className="d-flex flex-column align-items-center justify-content-center p-3">
                <div className="col-md-4 d-flex flex-column align-items-center justify-content-center">
                  <img src={viewImg} alt="Image" width={200} />
                  <p className="text-purple fw-bold text-center lh-base">
                    🔍 Your Data Search is Ready! Use the selected module
                    filters to search and explore relevant data across the
                    entire application with ease. 📂📈
                  </p>
                </div>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

const GlobalSearchElement = () => {
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [quickNotes, setQuickNotes] = useState(false);
  const [addGeneralTask, setAddGeneralTask] = useState(false);
  const [allNotes, setAllNotes] = useState([]);
  const token = secureLocalStorage.getItem("auth_token");
  const [boxWidth, setBoxWidth] = useState(0);
  const [lead_id, setLeadId] = useState("");
  const [currency_option, setCurrencyOption] = useState([]);
  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  const [selectedFiles1, setselectedFiles1] = useState([]);

  function handleAcceptedFiles1(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setselectedFiles1(files);
  }

  const getNotes = async (leadId) => {
    setLeadId(leadId);
    const response = await fetchNodeData(
      toggleLoading,
      `leadNotesData/${leadId}`,
      token,
    );
    if (response?.status) {
      setCurrencyOption(
        response.data.currency.map((item) => ({
          label: item.currency,
          value: item.id,
        })),
      );
      setAllNotes(response.data.notes);
      setQuickNotes(true);
    }
  };

  const column1 = useMemo(() => searchColumns(getNotes), []);

  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setBoxWidth(viewportWidth * 0.95);
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const onCloseAddModal = (close) => {
    setAddGeneralTask(close);
  };

  const [currency, setCurrency] = useState([]);
  const curentDateTime = moment().format("YYYY-MM-DDTHH:mm");
  const [notedate, setNotedate] = useState(curentDateTime);
  const [amount, setAmount] = useState("");
  const [ckedata, setCkedata] = useState("");

  const addNotes = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("lead_id", lead_id);
    formData.append("user_id", localStorage.getItem("auth_id"));
    formData.append("currency", currency.value != null ? currency.value : "");
    formData.append("date", notedate);
    formData.append("amount", amount);
    formData.append("description", ckedata);
    for (let i = 0; i < selectedFiles1.length; i++) {
      formData.append("files[]", selectedFiles1[i]);
    }
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/add_lead_note`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        setLoading(false);
        Swal.fire({
          icon: "success",
          text: "Note Added Successfully",
        }).then((data) => {
          setCkedata("");
          setAmount("");
          setAllNotes(response.data.data);
        });
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <>
        {isLoading && <Loader />}
        <div className="">
          <div>
            <Row>
              <Col lg="12">
                <Card>
                  <div className="responsive-table">
                    <TableContainer
                      columns={column1}
                      data={data}
                      toggleLoading={toggleLoading}
                      token={token}
                      setData={setData}
                    />
                  </div>
                </Card>
              </Col>
            </Row>
          </div>

          <Modal
            isOpen={quickNotes}
            toggle={() => {
              setQuickNotes(false);
            }}
            size="xl"
            className="bd-notes-search"
            centered
          >
            {isLoading && <Loader />}
            <div className="modal-header border-0">
              <h5 className="modal-title mt-0">Add Notes</h5>
              <button
                type="button"
                className="btn-modal-close"
                onClick={() => setQuickNotes(false)}
              >
                <span aria-hidden="true" className="btn-modal-span">
                  ×
                </span>
              </button>
            </div>
            <div className="modal-body pb-0">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="text-dark">Notes History</h5>
                  <div
                    className="mt-4"
                    style={{
                      maxHeight: "530px",
                      overflowY: "auto",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <ul className="verti-timeline list-unstyled notes-box">
                      {allNotes?.map((note, i) => {
                        return (
                          <li className="event-list position-relative" key={i}>
                            <div className="event-timeline-dot connected-dot">
                              <img
                                src={`${configure.imgUrl}${note?.addedby_avatar}`}
                                className="msgUserImg me-3"
                                alt="User Avatar"
                              />
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                                <div className="d-flex justify-content-start align-items-center">
                                  <div>
                                    <p className="text-muted ">
                                      <h6 className="d-inline me-2">
                                        By {note.added_by}
                                      </h6>{" "}
                                      {moment(note.created_at).format(
                                        "DD-MM-YYYY hh:mm:ss",
                                      )}
                                      <span className="pl-15">
                                        Got in touch with this lead at{" "}
                                        {moment(note.date).format(
                                          "DD-MM-YYYY hh:mm a",
                                        )}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                                <i className="bi bi-triangle-fill note-icon"></i>
                                <div
                                  className="Features word-wrap"
                                  dangerouslySetInnerHTML={{
                                    __html: note.description,
                                  }}
                                />
                                <p className="mb-2">
                                  Amount : {note.currency_symbol} {note.amount}{" "}
                                </p>
                                {note.link != null ? (
                                  <p className="mb-1">
                                    Attachment :{" "}
                                    <a
                                      target="_blank "
                                      className="btn btn-sm edit-delete-btn text-secondary ml-10"
                                      rel="noreferrer"
                                      type="button"
                                      href={note.link}
                                    >
                                      <i className="fas fa-eye"></i> View
                                    </a>
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
                    <Form className="w-100" onSubmit={addNotes}>
                      <Row className="align-items-center justify-content-between">
                        <div className="col-12 d-flex justify-content-between">
                          <h5 className="text-dark">Add New Note</h5>
                          <div className="text-end">
                            {/* <a
                              className="btn btn-save  me-2 btn-label"
                              onClick={() => setAddGeneralTask(true)}
                            >
                              <i className="fas fa-plus me-2 label-icon"></i>{" "}
                              Activity
                            </a>
                            */}
                            <a
                              className="btn btn-save  me-2 btn-label"
                              type="button"
                              href={`${configure.appUrl}calender/lead-${lead_id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className="fa fa-users me-2 label-icon"></i>
                              Add Meeting
                            </a>

                            <button className="btn btn-save  me-2 btn-label">
                              <i className="fas fa-plus me-2 label-icon"></i>Add
                              Note
                            </button>
                          </div>
                        </div>
                        <div className="" style={{ width: "98%" }}>
                          <label htmlFor="">Description</label>
                          <div
                            className="no-drag"
                            // onDoubleClick={() => setNoDrag(true)}
                            // onMouseLeave={() => setNoDrag(false)}
                            // onMouseEnter={() => setNoDrag(true)}
                          >
                            <CKEditor
                              editor={ClassicEditor}
                              data={ckedata}
                              onReady={(editor) => {}}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setCkedata(data);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 mt-3 px-0 ps-2">
                          <label htmlFor="">Currency</label>
                          <Select
                            onChange={(e) =>
                              setCurrency({
                                label: e.label,
                                value: e.value,
                              })
                            }
                            placeholder="Select Currency"
                            className="basic-multi-select"
                            classNamePrefix=" select"
                            styles={colourStyles}
                            options={currency_option}
                            menuPlacement="top"
                          />
                        </div>
                        <div className="col-md-3 mt-3  px-0 ps-2">
                          <label htmlFor="">Amount</label>
                          <input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter Amount"
                            className="form-control "
                          />
                        </div>
                        <div className="col-md-5 mt-3 notes pe-4">
                          <label htmlFor="touch">
                            Got in touch with this lead{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="datetime-local"
                            value={notedate}
                            onChange={(e) => setNotedate(e.target.value)}
                            required
                            className="form-control "
                          />
                        </div>

                        <div className="col-md-6 mt-3">
                          <label htmlFor="">Attachment</label>
                          <Dropzone
                            onDrop={(acceptedFiles) => {
                              handleAcceptedFiles1(acceptedFiles);
                            }}
                          >
                            {({ getRootProps, getInputProps }) => (
                              <div
                                className="dz-message needsclick p-0"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <div className="d-flex px-2 custom-file-upload align-items-center">
                                  <div className="">
                                    <i className="display-6 text-muted bx bxs-cloud-upload" />
                                  </div>
                                  <h5 className="mb-0 ms-2">Upload Files</h5>
                                </div>
                              </div>
                            )}
                          </Dropzone>
                        </div>
                        <div
                          className={`col-md-5 mt-3 dropzone-previews ${
                            selectedFiles1.length > 0 ? "d-block" : "d-none"
                          }`}
                          id="file-previews"
                        >
                          <label className="mb-1">Uploaded Files</label>
                          <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                            <div className="p-1">
                              <Row className="align-items-center justify-content-evenly">
                                {selectedFiles1.map((f, i) => {
                                  return (
                                    <Col key={i} className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        height="80"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                  );
                                })}
                              </Row>
                            </div>
                          </Card>
                        </div>
                      </Row>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            isOpen={addGeneralTask}
            toggle={() => {
              setAddGeneralTask(false);
            }}
            size="xl"
            className="bd-notes-search"
            centered
          >
            <div className="modal-body pt-0 ps-0">
              <AddTasks
                // alldependency={alldependency}
                // tasks={tasks}
                onCloseAddModal={onCloseAddModal}
                toggleLoading={toggleLoading}
              />
            </div>
          </Modal>
        </div>
      </>
    </React.Fragment>
  );
};

export default GlobalSearchElement;
